import {FC, useMemo, useState} from 'react';
import {ContentBox} from '@components/ContentBox';
import {Typography} from '@components/Typography';
import {Row} from '@components/Row';
import {Button, Col, Divider, Form, InfoTooltip, InputGroup} from '@components/index';
import {FormattedMessage, FormattedNumber, useIntl} from 'react-intl';
import {Currency} from '.cache/__types__';
import {getCurrencySymbol} from '@utils/locale';
import {useMQ} from '@hooks/useMQ';

export type OwnestProps = {};

export const Ownest: FC<OwnestProps> = ({}) => {
    return (
        <ContentBox className="px-5 py-6 px-xl-8 py-xl-10">
            <Typography as="p" variant="perex">
                <FormattedMessage defaultMessage={'Potřebujete dospořit jistinu hypotéky? Máme řešení'} />
            </Typography>

            <Divider />

            <Typography as={"h2"} variant={"subheadline"} className="mb-3 mb-lg-6">
                <FormattedMessage defaultMessage={"Můj první byt od OWNEST"} />
            </Typography>

            <Row className="g-5 mb-5">
                <Col>
                    <Typography color={"grey-dark"} >
                    <ul>
                        <li className={"mb-3"}>
                                <FormattedMessage defaultMessage={"Váš byt koupíme za vás a vy bydlíte ve svém vysněném domově hned"} />
                        </li>
                        <li className={"mb-3"}>
                            <FormattedMessage defaultMessage={"Na začátku potřebujete mít naspořeny pouze 3 % hodnoty bytu"} />
                        </li>
                        <li>
                            <FormattedMessage defaultMessage={"Postupně si šetříte na 10 - 20 % hodnoty bytu a máte až 5 let čas na získání hypotéky"} />
                        </li>
                    </ul>
                    </Typography>
                </Col>
            </Row>

            <Row className="justify-content-lg-center">
                <Col xs={12} lg="auto">
                    <Button href="https://www.ownest.cz/?utm_source=bezrealitky.cz&utm_medium=banner&utm_campaign=ownest+promo" className="w-100">
                        <FormattedMessage defaultMessage={'Zjistit více informací'} />
                    </Button>
                </Col>
            </Row>
        </ContentBox>
    );
};
